/* Laurentide homepage sections — small, dependency-free helpers. Only touches elements inside .lt */
(function () {
  'use strict';
  window.ltLoaded = true;
  var root = document.documentElement;
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o); }
  function store(key, val) {
    try { if (val === undefined) return JSON.parse(localStorage.getItem(key)); localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; }
  }

  /* Scroll reveal */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-revealed'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  function initReveal(ctx) {
    qsa('.lt [data-reveal]:not(.is-revealed)', ctx).forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-revealed'); });
  }

  /* Countdown to the real end date set in theme settings */
  function initCountdowns(ctx) {
    qsa('.lt [data-countdown]', ctx).forEach(function (el) {
      if (el.__cd) return; el.__cd = true;
      var p = (el.getAttribute('data-countdown') || '').split('-').map(Number);
      if (p.length !== 3 || p.some(isNaN)) return;
      var end = new Date(p[0], p[1] - 1, p[2], 23, 59, 59);
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      function tick() {
        var d = end - new Date();
        if (d <= 0) { el.hidden = true; return false; }
        el.hidden = false;
        el.querySelector('[data-cd-d]').textContent = Math.floor(d / 864e5);
        el.querySelector('[data-cd-h]').textContent = pad(Math.floor(d % 864e5 / 36e5));
        el.querySelector('[data-cd-m]').textContent = pad(Math.floor(d % 36e5 / 6e4));
        el.querySelector('[data-cd-s]').textContent = pad(Math.floor(d % 6e4 / 1e3));
        return true;
      }
      if (tick()) { var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000); }
    });
  }

  /* Shop the look */
  function initLooks(ctx) {
    qsa('.lt [data-look]', ctx).forEach(function (wrap) {
      var dots = qsa('[data-hotspot]', wrap), items = qsa('[data-look-item]', wrap);
      function activate(i) {
        dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-hotspot') === String(i)); });
        items.forEach(function (it) { it.classList.toggle('is-active', it.getAttribute('data-look-item') === String(i)); });
      }
      dots.forEach(function (d) {
        on(d, 'click', function () { var i = d.getAttribute('data-hotspot'); activate(i); if (items[i] && window.matchMedia('(max-width: 989px)').matches) items[i].scrollIntoView({ behavior: 'smooth', block: 'center' }); });
        on(d, 'mouseenter', function () { activate(d.getAttribute('data-hotspot')); });
      });
      items.forEach(function (it) { on(it, 'mouseenter', function () { activate(it.getAttribute('data-look-item')); }); });
    });
  }

  /* FAQ topic filter */
  function initFaq(ctx) {
    qsa('.lt [data-faq]', ctx).forEach(function (wrap) {
      var chips = qsa('[data-faq-filter]', wrap), items = qsa('[data-faq-cat]', wrap);
      chips.forEach(function (chip) {
        on(chip, 'click', function () {
          var f = chip.getAttribute('data-faq-filter');
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
          items.forEach(function (it) { it.hidden = !(f === 'all' || it.getAttribute('data-faq-cat') === f); });
        });
      });
    });
  }

  /* Colour swatches on product cards swap the image */
  on(document, 'mouseover', function (e) {
    var dot = e.target.closest && e.target.closest('.lt .swatch-dot[data-swatch-img]');
    if (!dot) return;
    var card = dot.closest('[data-card]'), img = card && card.querySelector('.card__img');
    if (!img) return;
    img.removeAttribute('srcset'); img.src = dot.getAttribute('data-swatch-img');
    qsa('.swatch-dot', card).forEach(function (d) { d.classList.toggle('is-active', d === dot); });
  });

  /* Sale pop-up */
  function initPopup(ctx, force) {
    qsa('[data-lt-popup]', ctx).forEach(function (pop) {
      if (pop.__init && !force) return; pop.__init = true;
      var key = 'laurentide:popup';
      var days = parseInt(pop.getAttribute('data-days'), 10) || 7;
      var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 6) * 1000;
      var last = store(key);
      var lastFocus = null;
      function open() {
        if (!pop.hidden) return;
        lastFocus = document.activeElement;
        pop.hidden = false;
        var f = pop.querySelector('.lt-popup__cta'); if (f) f.focus({ preventScroll: true });
      }
      function close() {
        pop.hidden = true;
        store(key, Date.now());
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }
      qsa('[data-popup-close]', pop).forEach(function (b) { on(b, 'click', close); });
      on(pop.querySelector('[data-popup-accept]'), 'click', function () { store(key, Date.now()); });
      on(document, 'keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
      pop.__open = open; pop.__close = function () { pop.hidden = true; };
      if (window.Shopify && window.Shopify.designMode) return;
      if (pop.querySelector('.form-message')) { open(); return; }
      if (last && Date.now() - last < days * 864e5) return;
      var timer = setTimeout(open, delay);
      if (pop.getAttribute('data-exit') === 'true' && window.matchMedia('(pointer: fine)').matches) {
        on(document, 'mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(timer); open(); } });
      }
    });
  }

  function initAll(ctx) { initReveal(ctx); initCountdowns(ctx); initLooks(ctx); initFaq(ctx); initPopup(ctx); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    qsa('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-revealed'); });
  });
  document.addEventListener('shopify:section:select', function (e) {
    qsa('[data-reveal]', e.target).forEach(function (el) { el.classList.add('is-revealed'); });
    var pop = e.target.querySelector('[data-lt-popup]'); if (pop) { initPopup(e.target); if (pop.__open) pop.__open(); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var pop = e.target.querySelector('[data-lt-popup]'); if (pop && pop.__close) pop.__close();
  });
})();
